import { render, staticRenderFns } from "./PaginationColor.vue?vue&type=template&id=9a44ce8a&"
import script from "./PaginationColor.vue?vue&type=script&lang=js&"
export * from "./PaginationColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports